import { Directive, ElementRef, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[matTooltip][appShowMatTooltipIfDisabled]',
  standalone: false,
})
export class ShowMatTooltipIfDisabledDirective {
  private readonly matTooltip = inject(MatTooltip);
  private elementRef: ElementRef<HTMLButtonElement> = inject(ElementRef<HTMLButtonElement>);

  public ngOnInit(): void {
    this.matTooltip.disabled = !this.elementRef.nativeElement.disabled;
  }
}
